import { z } from 'zod';

export const paginationMetaSchema = z.object({
  cursor: z.string().optional(),
  limit: z.number(),
  hasNextPage: z.boolean(),
  total: z.number(),
});

export const apiResponse = <T extends z.ZodTypeAny>(data: T) =>
  z.object({
    data,
    success: z.boolean(),
    message: z.string().optional(),
    pagination: paginationMetaSchema.optional(),
  });

export const apiError = z.object({
  message: z.string(),
});

export type PaginationMetaDto = z.infer<typeof paginationMetaSchema>;
